export default "__VITE_ASSET__BiX98_bd__"